export default __webpack_public_path__ + "static/media/globe-joypixels.073e214c.gif";